// extracted by mini-css-extract-plugin
module.exports = {"root":"VideoPreview_root__3-RhO","video":"VideoPreview_video__1u-ZW"};